import { Module } from '@nestjs/common';
import { MysqlService } from './mysql.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AttachmentsEntity, ClientsEntity, CompanyEntity, FinancialsEntity, LeadsEntity, MonitoringAttachmentsEntity, MonitoringsEntity, ProposalAttachmentsEntity, ProposalItemsEntity, ProposalPricingSummaryEntity, ProposalsEntity, SaleAttachmentsEntity, SalesEntity, UsersEntity } from '@crm/dto';

@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: process.env.DB_HOST,
      port: parseInt(process.env.DB_PORT || '3306'),
      username: process.env.DB_USER,
      password: process.env.DB_PASSWORD,
      database: process.env.DB_NAME,
      entities: [__dirname + '/../**/*.entity{.ts,.js}'],
      synchronize: false,
      autoLoadEntities: true, 
      connectTimeout: 10000,
      retryAttempts: 5,
      retryDelay: 3000, 
    }),
    TypeOrmModule.forFeature([
      AttachmentsEntity,
      ClientsEntity,
      CompanyEntity,
      FinancialsEntity,
      LeadsEntity,
      MonitoringsEntity,
      MonitoringAttachmentsEntity,
      ProposalsEntity,
      ProposalItemsEntity,
      ProposalAttachmentsEntity,
      ProposalPricingSummaryEntity,
      SalesEntity,
      SaleAttachmentsEntity,
      UsersEntity,
    ]),
  ],
  exports: [MysqlService],
  providers: [MysqlService],
})
export class MysqlModule {}
